import { FormControl } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { MonitorUrlFieldInput } from 'components/status-checks/form/status-check/common/MonitorUrlFieldInput'
import { useGetFirstMatchingStatusCheckIdByMonitorUrl } from 'components/status-checks/hooks/use-get-first-matching-status-check-id-by-monitor-url'
import {
  type StatusCheckFormValues,
  StatusCheckMonitorSelectionRadioValue
} from 'components/status-checks/status-checks-form-utils'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'

const fieldsToWatch = ['externalIntegration'] as const
const statusChecksUrls = getStatusChecksUrls()

export const DatadogMonitorURL: React.FC<{
  radioValue: StatusCheckMonitorSelectionRadioValue
}> = ({ radioValue }) => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const [externalIntegration] = useWatch({ control, name: fieldsToWatch })
  const firstMatchingStatusCheckIdWithDuplicateMonitorUrl =
    useGetFirstMatchingStatusCheckIdByMonitorUrl()

  return (
    <FormControl>
      <Controller
        control={control}
        name="monitorUrl"
        render={({ field, fieldState }) => (
          <MonitorUrlFieldInput
            disabled={radioValue !== StatusCheckMonitorSelectionRadioValue.URL}
            externalIntegration={externalIntegration}
            field={field}
            fieldState={fieldState}
            {...(firstMatchingStatusCheckIdWithDuplicateMonitorUrl && {
              to: statusChecksUrls.edit(
                firstMatchingStatusCheckIdWithDuplicateMonitorUrl
              )
            })}
          />
        )}
      />
    </FormControl>
  )
}
